class TimerEvent {

	// state changes

	get CHANGING() { return 'timer-event__changing'; }
	get PAUSING() { return 'timer-event__pausing'; }
	get PLAYING() { return 'timer-event__playing'; }
	get POLLING() { return 'timer-event__polling'; }

	// commands

	get ADD_TIME() { return 'timer-event__addTime'; }
	get PAUSE() { return 'timer-event__pause'; }
	get PLAY() { return 'timer-event__play'; }
	get SEEK() { return 'timer-event__seek'; }
	get POLL_STATUS() { return 'timer-event__pollStatus'; }
	get CHANGE() { return 'timer-event__change'; }

}

export default new TimerEvent();
